// FooterSection.js
import React from "react";

const FooterSection = () => {
  return (
    <footer className="footer-section bg-title fix">
      <div className="footer-widgets-wrapper">
        <div className="shape1 float-bob-y d-none d-xxl-block">
          <img src="/assets/img/shape/footerShape1_1.png" alt="shape" />
        </div>
        <div className="shape2 d-none d-xxl-block">
          <img src="/assets/img/shape/footerShape1_2.png" alt="shape" />
        </div>
        <div className="shape3 d-none d-xxl-block">
          <img src="/assets/img/shape/footerShape1_3.png" alt="shape" />
        </div>
        <div className="shape4 d-none d-xxl-block">
          <img src="/assets/img/shape/footerShape1_4.png" alt="shape" />
        </div>

        <div className="container">
          <div className="footer-top">
            <div className="row gy-4">
              {/* Address */}
              <div className="col-lg-4">
                <div className="fancy-box">
                  <div className="item1">
                    <i className="fa-solid fa-location-dot"></i>
                  </div>
                  <div className="item2">
                    <h6>Address</h6>
                    <p>Shop No: G/17, Devpreet Complex, Visat Gandhinagar Highway Road </p>
                  </div>  
                </div>
              </div>

              {/* Email */}
              <div className="col-lg-4 d-flex justify-content-start justify-content-lg-end">
                <div className="fancy-box">
                  <div className="item1">
                    <i className="fa-solid fa-envelope"></i>
                  </div>
                  <div className="item2">
                    <h6>Send Email</h6>
                    <p>thespiceroot.com</p>
                  </div>
                </div>
              </div>

              {/* Phone */}
              <div className="col-lg-4 d-flex justify-content-start justify-content-lg-end">
                <div className="fancy-box">
                  <div className="item1">
                    <i className="fa-regular fa-phone-volume"></i>
                  </div>
                  <div className="item2">
                    <h6>Contact Us</h6>
                    <p>+91 78743 43757</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {/* Logo + About */}
            <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".2s">
              <div className="single-footer-widget">
                <div className="widget-head">
                  <a href="/">
                    <img src="/assets/img/logo/1.png" alt="logo-img" />
                  </a>
                  <p>Catering & Events Organizer</p>
                  <p>Sharing Quality with Joy…<br></br>
                  Premium Catering for Auspicious Occasions</p>
                </div>
                <div className="footer-content">
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-xl-3 col-lg-4 col-md-6 ps-xl-5 wow fadeInUp" data-wow-delay=".4s">
              <div className="single-footer-widget">
                <div className="widget-head">
                  <h3>Quick Links</h3>
                </div>
                <ul className="list-area">
                  {["About ","Menu","Pick Your Dishes","Gallery","Contact"].map((link, i) => (
                    <li key={i}>
                      <a href={`${link.toLowerCase().replace(/\s/g,"")}`}>
                        <i className="fa-solid fa-chevrons-right"></i> {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Our Menu */}
            <div className="col-xl-3 col-lg-4 col-md-6 ps-xl-5 wow fadeInUp" data-wow-delay=".4s">
              <div className="single-footer-widget">
                <div className="widget-head">
                  <h3>Our Menu</h3>
                </div>
                <ul className="list-area">
                  {["Menu 1","Menu 2","Menu 3","Menu 4","Menu 5" , "Menu 6","Menu 7"].map((item,i)=>(
                    <li key={i}>
                      <a href="menu">
                        <i className="fa-solid fa-chevrons-right"></i> {item}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-xl-3 col-lg-4 col-md-6 ps-xl-5 wow fadeInUp" data-wow-delay=".4s">
              <div className="single-footer-widget">
                <div className="widget-head">
                  <h3>Contact Us</h3>
                </div>
                <ul className="list-area">
                  <li className="mb-2">
                    Sunday - Saturday  <span className="text-theme-color2"> 10am –  11pm </span>
                  </li>
                  {/* <li>
                    Saturday: <span className="text-theme-color2"> 8am – 12am </span>
                  </li> */}
                </ul>
                       <div className="footer-content">
                   <div className="social-icon d-flex align-items-center">
                    <a href="https://www.facebook.com/thespicerootcaterers/" target="_blank"><i className="fab fa-facebook-f"></i></a>
                    <a href="https://www.instagram.com/thespicerootcaterers/" target="_blank"><i className="fab fa-instagram"></i></a>
                    <a href="https://www.youtube.com/@thespicerootcaterers/" target="_blank"><i className="fa-brands fa-youtube"></i></a>
                  </div>
                  </div>
             
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
       <div className="footer-bottom">
      <div className="container">
        <div className="footer-wrapper d-flex align-items-center justify-content-between">
          <p
            className="wow fadeInLeft"
            data-wow-delay=".3s"
          >
            © All Copyright 2026 by{" "}
            <a href="/" className="text-white">
              The Spice Root
            </a>
          </p>

          <ul
            className="brand-logo wow fadeInRight"
            data-wow-delay=".5s"
          >
            <li>
              <a className="text-white" href="/terms">
                Terms &amp; Condition
              </a>
            </li>
            <li>
              <a className="text-white" href="/privacy">
                Privacy Policy
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    </footer>
  );
};

export default FooterSection;
